import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { Filesystem, Directory } from '@capacitor/filesystem';

// Envoi des photos composées (M5bis).
//
// Un lien wa.me ne transporte que du TEXTE : pour des photos, on passe par la
// feuille de partage du système — l'utilisateur y choisit WhatsApp Business
// puis la conversation, et les photos partent en lot (limite WhatsApp : le
// destinataire se choisit dans WhatsApp, pas en amont).
//  - APK Android : Filesystem (cache) + Share.share({ files }) ;
//  - navigateur compatible (Android Chrome…) : navigator.share({ files }) ;
//  - repli bureau : téléchargement des photos composées, prêtes à glisser
//    dans WhatsApp Web.

const blobEnBase64 = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(',')[1]);
  r.onerror = () => reject(new Error('Lecture image impossible'));
  r.readAsDataURL(blob);
});

const telecharger = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};

/**
 * Partage les photos { blob, fileName }. Renvoie le canal utilisé :
 * 'partage-natif' | 'partage-web' | 'telechargement'.
 */
export default async function partagerPhotos(photos) {
  if (!photos.length) return 'rien';

  if (Capacitor.isNativePlatform()) {
    const uris = [];
    for (const p of photos) {
      const data = await blobEnBase64(p.blob);
      const ecrit = await Filesystem.writeFile({
        path: `partage/${p.fileName}`,
        data,
        directory: Directory.Cache,
        recursive: true,
      });
      uris.push(ecrit.uri);
    }
    await Share.share({ files: uris, dialogTitle: 'Partager les photos Ndoé' });
    return 'partage-natif';
  }

  if (navigator.canShare) {
    const files = photos.map((p) => new File([p.blob], p.fileName, { type: 'image/jpeg' }));
    if (navigator.canShare({ files })) {
      await navigator.share({ files, title: 'Ndoé Boutique' });
      return 'partage-web';
    }
  }

  for (let i = 0; i < photos.length; i += 1) {
    telecharger(photos[i].blob, photos[i].fileName);
    // Laisser respirer le navigateur entre deux téléchargements.
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, 350));
  }
  return 'telechargement';
}

/**
 * Enregistre les photos EN LOCAL (sans passer par WhatsApp) — demande proprio
 * 18/07 : « pouvoir soit télécharger sur mon téléphone/PC, soit partager ».
 *  - APK Android : Filesystem → Directory.Documents (dossier « Ndoe » visible
 *    dans les fichiers du téléphone) ;
 *  - navigateur (PC ou téléphone) : téléchargement classique de chaque photo.
 * Renvoie { canal, dossier? } pour un message clair à l'utilisateur.
 */
export async function telechargerPhotos(photos) {
  if (!photos.length) return { canal: 'rien' };

  if (Capacitor.isNativePlatform()) {
    for (const p of photos) {
      const data = await blobEnBase64(p.blob);
      // eslint-disable-next-line no-await-in-loop
      await Filesystem.writeFile({
        path: `Ndoe/${p.fileName}`,
        data,
        directory: Directory.Documents,
        recursive: true,
      });
    }
    return { canal: 'appareil', dossier: 'Documents/Ndoe' };
  }

  for (let i = 0; i < photos.length; i += 1) {
    telecharger(photos[i].blob, photos[i].fileName);
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, 350));
  }
  return { canal: 'navigateur' };
}
